// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview[data-v-84f80758] {\n  min-height: 80vh;\n}\n.jsoneditor[data-v-84f80758] {\n  min-height: 80vh;\n}\n", ""]);
// Exports
module.exports = exports;
